/**
 * Templates — list, create, duplicate, delete.
 *
 * The list deliberately fetches metadata only; a rendered template runs to
 * hundreds of KB and the editor loads the body on demand.
 */
define('mailingTemplatesView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'mailingShell',
  'entities/mailing'
], function (
  module,
  App,
  _,
  $,
  Marionette,
  Shell,
  MailingApi
) {
  'use strict';

  var TemplatesView = Marionette.ItemView.extend({

    className: 'mailing-page mailing-templates',

    template: _.template(
      '<%= nav %>' +
      '<div class="mlg-body"><div class="mlg-loading">Loading templates…</div></div>' +
      '<div class="mlg-modal" style="display:none"></div>'
    ),

    ui: {
      body: '.mlg-body',
      modal: '.mlg-modal'
    },

    events: {
      'click .mlg-new-template': 'onNew',
      'click .mlg-open': 'onOpen',
      'click .mlg-duplicate': 'onDuplicate',
      'click .mlg-delete': 'onDelete',
      'click .mlg-modal-cancel': 'closeModal',
      'click .mlg-modal-save': 'onCreate'
    },

    serializeData: function () {
      return {
        nav: Shell.navHtml('templates',
          '<button type="button" class="mlg-btn primary mlg-new-template">New template</button>')
      };
    },

    onShow: function () {
      this.load();
    },

    load: function () {
      var self = this;
      MailingApi.templates().done(function (templates) {
        self.renderList(templates || []);
      }).fail(function (xhr) {
        self.ui.body.html('<div class="mlg-error">' + _.escape(MailingApi.errorMessage(xhr)) + '</div>');
      });
    },

    renderList: function (templates) {
      if (!templates.length) {
        this.ui.body.html(Shell.emptyHtml('No template yet. Create one to start designing an email.'));
        return;
      }
      var rows = _.map(templates, function (template) {
        return '<tr data-secid="' + template.secId + '">' +
          '<td class="c-name">' +
          '  <a class="mlg-open" href="#mailing/templates/' + template.secId + '">' +
               _.escape(template.name || '(untitled)') + '</a>' +
          '  <div class="c-sub">' + _.escape(template.subject || '') + '</div>' +
          '</td>' +
          '<td>' + _.escape(template.language || 'EN') + '</td>' +
          '<td>' + Shell.formatDate(template.modDate, true) + '</td>' +
          '<td class="c-actions">' +
          '  <button type="button" class="mlg-btn small mlg-duplicate">Duplicate</button>' +
          '  <button type="button" class="mlg-btn small danger mlg-delete">Delete</button>' +
          '</td></tr>';
      }).join('');

      this.ui.body.html(
        '<table class="mlg-table">' +
        '<thead><tr><th>Template</th><th>Language</th><th>Last modified</th><th></th></tr></thead>' +
        '<tbody>' + rows + '</tbody></table>');
    },

    onNew: function () {
      this.ui.modal.html(
        '<div class="mlg-modal-card narrow">' +
        '<h3>New template</h3>' +
        '<label>Name<input type="text" class="f-name"></label>' +
        '<label>Subject<input type="text" class="f-subject"></label>' +
        '<label>Language<input type="text" class="f-language" value="EN"></label>' +
        '<div class="mlg-modal-actions">' +
        '  <button type="button" class="mlg-btn mlg-modal-cancel">Cancel</button>' +
        '  <button type="button" class="mlg-btn primary mlg-modal-save">Create and design</button>' +
        '</div>' +
        '</div>').show();
    },

    onCreate: function () {
      var self = this;
      var name = this.ui.modal.find('.f-name').val();
      if (!name) {
        Shell.banner(this.$el, 'Name is required', 'error');
        return;
      }
      MailingApi.createTemplate({
        name: name,
        subject: this.ui.modal.find('.f-subject').val(),
        language: this.ui.modal.find('.f-language').val() || 'EN',
        htmlContent: '',
        designJson: ''
      }).done(function (template) {
        self.closeModal();
        App.navigate('mailing/templates/' + template.secId, { trigger: true });
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    /** Copies the body too, so a duplicate opens ready to tweak. */
    onDuplicate: function (e) {
      var self = this;
      MailingApi.template(this.secIdOf(e)).done(function (template) {
        MailingApi.createTemplate({
          name: (template.name || 'Template') + ' (copy)',
          subject: template.subject,
          language: template.language,
          htmlContent: template.htmlContent,
          designJson: template.designJson
        }).done(function () {
          Shell.banner(self.$el, 'Template duplicated', 'ok');
          self.load();
        }).fail(function (xhr) {
          Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
        });
      });
    },

    onDelete: function (e) {
      var self = this;
      var name = $(e.currentTarget).closest('tr').find('.c-name a').text();
      if (!window.confirm('Delete "' + name + '"? Campaigns using it will need a new template.')) { return; }

      MailingApi.deleteTemplate(this.secIdOf(e)).done(function () {
        Shell.banner(self.$el, 'Template deleted', 'ok');
        self.load();
      }).fail(function (xhr) {
        Shell.banner(self.$el, MailingApi.errorMessage(xhr), 'error');
      });
    },

    onOpen: function (e) {
      e.preventDefault();
      App.navigate($(e.currentTarget).attr('href').substring(1), { trigger: true });
    },

    closeModal: function () {
      this.ui.modal.hide().empty();
    },

    secIdOf: function (e) {
      return $(e.currentTarget).closest('tr').data('secid');
    }
  });

  module.exports = TemplatesView;
});

